module.exports = __webpack_public_path__ + "img/setting-08.8150cf2b.png";